import axios from "axios";
import packageJson from "../../../package.json";
import { IImage } from "../types/Types";

export const LoadImage = (id: string): Promise<IImage> => {
  return axios
    .get<IImage>(packageJson.server + `/getBlolb/${id}?format=json`)
    .then((res) => res.data);
};
